module.exports = __webpack_public_path__ + "static/media/fitness.e16a8a3f.png";